export default __webpack_public_path__ + "static/media/GridActive.1a8fc38b.svg";